import React from 'react';
import './Home.css';
import { TbDeviceDesktopCode } from "react-icons/tb";
import { MdImageSearch } from "react-icons/md";
import { TbDeviceImacSearch } from "react-icons/tb";
import { SiChatbot } from "react-icons/si";
import { TbSettingsAutomation } from "react-icons/tb";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";  
import "swiper/css";

const HomeServices = () => {
  const cardsData = [
    {
      id: 1,
      title: <>Website Design <br/> <b>And Development</b></>,
      img: "/development.webp",
      icon:<TbDeviceDesktopCode />,
      link:"/web-development"
    },
    {
      id: 2,
      title: <>Search Engine <br/><b> Optimization</b></>,
      img: "/seo.webp",
      icon: <MdImageSearch />,
      link:"/search-engine-optimization"
    },
    {
      id: 3,
      title: <>Social Media <br/><b> Marketing</b></>,
      img: "/marketing.webp",
      icon: <TbDeviceImacSearch />,
      link:"/social-media-marketing"
    },
    {
      id: 4,
      title: <>Chat Bot <br/><b> Development</b></>,
      img: "/chatbot.webp",
      icon: <SiChatbot />,
      link:"/chat-bot-development"
    },
     {
      id: 5,
      title: <> Data & Automation <br/><b> Services</b></>,
      img: "/data&auto.webp",
      icon: <TbSettingsAutomation />,
      link:"/data-and-automation-services"
    },
  ];

  return (
    <div className='backdiv'>
      <h2 className='main_heading'>
        SERVICES FOR ALL <br/>YOUR MARKETING NEEDS
      </h2>

      {/* Desktop View */}
      <div className="marketing_cards_container">
        {cardsData.map((card) => (
          <a href={card.link} key={card.id} className="home_services_link">
            <div className="home_services_card">
              <div className="homecard_imgdiv">
                <img className='zweedo_img' src={card.img} alt="service" loading='lazy'/>
                <div className="card-icon">
                  <p className='react_icons'>{card.icon}</p>
                </div>
              </div>
              <div className="homeservices_card_content">
                <p className='services_title'>{card.title}</p>
              </div>
            </div>
          </a>
        ))}
      
      </div>

      {/* Mobile Swiper */}
      <div className="marketing_card_mobile_view">
        <Swiper
          modules={[ Autoplay]} 
          spaceBetween={0}
          loop={true} 
          autoplay={{
            delay: 2500, 
            disableOnInteraction: false, 
          }}
          breakpoints={{
            0: { slidesPerView: 1 },
            480: { slidesPerView: 1 },
            768: { slidesPerView: 3 },
            992: { slidesPerView: 3 },
          }}
        >
          {cardsData.map((card) => (
            <SwiperSlide key={card.id}>
              <div className='swiper_wrapper_div'>
                <a href={card.link} className="home_services_link">
                  <div className="home_services_card">
                    <div className="homecard_imgdiv">
                      <img className='zweedo_img' src={card.img} alt="service" loading='lazy'/>
                      <div className="card-icon">
                        <p className='react_icons'>{card.icon}</p>
                      </div>
                    </div>
                    <div className="homeservices_card_content">
                      <p className='services_title'>{card.title}</p>
                    </div>
                  </div>
                </a>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
        <div className='ser_btn_div'>
  <a href='/services'>
  <button className='read_btn'>Read more</button></a>
</div>

     
    </div>
  );
};

export default HomeServices;
